/**
 * Pure constructors for the typed failure contract: `okOutcome` / `degradedOutcome` build the two branches of
 * `Outcome<T, R>`. Both branches carry `value`, so a caller that previously consumed a silent fallback migrates by
 * destructuring `.value`; degrade sites additionally surface a snake_case `reason` token and the caught `cause`.
 */

import type { DegradedOutcome, OkOutcome } from '@federa/types/observability-outcome';

export function okOutcome<T>(value: T): OkOutcome<T> {
	return { ok: true, value };
}

/** Wrap a fallback value in the degraded branch, carrying the snake_case `reason` token and the optional caught `cause`. */
export function degradedOutcome<T, R extends string = string>(value: T, reason: R, cause?: unknown): DegradedOutcome<T, R> {
	return { ok: false, value, reason, cause };
}
